import { Instance } from 'mobx-state-tree';
import Cookies from 'universal-cookie';
import createConnection from './utils/createConnection';
import App from './App';
import config from '../../config';
import { getInitialInternalToolsUIState } from './InternalToolsUI';
import { getInitialOrdersPageState } from './OrdersPage';

const cookies = new Cookies();

// Defer @routific/hive imports to avoid circular dependency issues
let hiveImports: any = null;

const getHiveImports = async () => {
  if (!hiveImports) {
    const hive = await import('@routific/hive');
    hiveImports = {
      message: hive.message,
      closeMessage: hive.closeMessage,
      closeAllMessages: hive.closeAllMessages,
      configureMessages: hive.configureMessages,
      notification: hive.notification,
      closeNotification: hive.closeNotification,
    };

    // Configure messages after import
    if (hiveImports.configureMessages) {
      hiveImports.configureMessages({
        maxCount: 10,
      });
    }
  }
  return hiveImports;
};

const env = {
  message: (...args: any[]) => getHiveImports().then(h => h.message?.(...args)),
  closeMessage: (...args: any[]) => getHiveImports().then(h => h.closeMessage?.(...args)),
  closeAllMessages: (...args: any[]) => getHiveImports().then(h => h.closeAllMessages?.(...args)),
  notification: (...args: any[]) => getHiveImports().then(h => h.notification?.(...args)),
  closeNotification: (...args: any[]) => getHiveImports().then(h => h.closeNotification?.(...args)),
  ...createConnection({
    apiUri: config.routificApi.planningService.url.base,
    gqlUri: `${config.routificApi.planningService.url.base}/graphql`,
  }),
};

const app = App.create({
  auth: { token: cookies.get('access_token') },
  ui: {
    disableConfirmReoptimizeModal: JSON.parse(localStorage.getItem('disableConfirmReoptimizeLassoModal') || 'false'),
    disableConfirmDeleteVisitModal: JSON.parse(localStorage.getItem('disableConfirmDeleteVisitModal') || 'false'),
    disableConfirmDeleteCustomerModal: JSON.parse(localStorage.getItem('disableConfirmDeleteCustomerModal') || 'false'),
    disableConfirmScheduleWarningModal: JSON.parse(localStorage.getItem('disableConfirmScheduleWarningModal') || 'false'),
    disableConfirmChangeDeliveryMethodModal: JSON.parse(localStorage.getItem('disableConfirmChangeDeliveryMethodModal') || 'false'),
  },
  internalToolsUI: getInitialInternalToolsUIState(),
  ordersPage: getInitialOrdersPageState(),
}, env);

export interface AppType extends Instance<typeof app> {
}

// TODO: Remove this or only expose it in dev envs
export type AppEnv = typeof env;

(window as any).store = app;

export default app;

export { useQuery, useStore } from './utils/hooks';
export { MSTProvider } from './utils/mstProvider';
